/* CUBE STORE - collezioni (app Globo)
   1) sposta il tasto FILTRI accanto alla barra di ricerca;
   2) mette le etichette del pannello in italiano;
   3) aggiunge lo sfondo scuro cliccabile e la chiusura con Esc;
   4) posiziona il pannello a destra e sotto la testata, azzerando margine
      e altezza dell'app (li imposta con una regola piu specifica del tema);
   5) porta il nome del colore fuori dal titolo, su una riga sotto;
   6) rete di sicurezza se l'app non parte. */
(function () {
  function closePanel() {
    var btn = document.querySelector('.gf-close-canvas');
    if (btn) btn.click();
    else document.documentElement.classList.remove('offcanvas-open');
  }

  /* ---------- 1. tasto FILTRI accanto alla ricerca ---------- */

  function placeTrigger() {
    var form = document.querySelector('.gf-controls-search-form');
    var trigger = document.querySelector('.gf-filter-trigger');
    if (!form || !trigger) return;

    var row = document.querySelector('.cube-search-row');
    if (!row) {
      row = document.createElement('div');
      row.className = 'cube-search-row';
      form.parentElement.insertBefore(row, form);
    }
    if (form.parentElement !== row) row.appendChild(form);
    if (trigger.parentElement !== row) row.appendChild(trigger);
  }

  /* ---------- 2. etichette ---------- */

  function setText(el, text) {
    if (el && el.textContent.trim() !== text) el.textContent = text;
  }

  function labels() {
    var btn = document.querySelector('.gf-refine-toggle-mobile button');
    if (btn) {
      btn.setAttribute('aria-label', 'Filtri');
      var kids = btn.childNodes;
      for (var i = 0; i < kids.length; i++) {
        if (kids[i].nodeType === 3 && kids[i].nodeValue.trim() && kids[i].nodeValue.indexOf('Filtri') === -1) {
          kids[i].nodeValue = ' Filtri';
        }
      }
    }

    setText(document.getElementById('gf-filter-title'), 'Filtri');
    setText(document.querySelector('.globo-selected-items-wrapper .gf-block-title .h3 span'), 'Filtri attivi');

    var x = document.querySelector('.gf-close-canvas');
    if (x) x.setAttribute('aria-label', 'Chiudi filtri');
  }

  /* ---------- 3. geometria del pannello ---------- */
  /* La testata e' sticky e occupa sempre la stessa fascia in alto, quindi
     il suo bordo inferiore e' il punto di partenza del pannello. Lo misuro
     dal DOM invece di scriverlo a mano: cosi vale anche su mobile, dove la
     testata e' piu bassa, e se un domani sparisce la barra annunci. */

  function headerBottom() {
    var header = document.querySelector('.header');
    if (!header) return 0;
    var bottom = Math.round(header.getBoundingClientRect().bottom);
    return bottom > 0 ? bottom : 0;
  }

  function panel() {
    var tree = document.getElementById('gf-tree');
    if (!tree) return;

    var top = headerBottom();
    if (tree.dataset.cubeTop === String(top)) return;
    tree.dataset.cubeTop = String(top);

    document.documentElement.style.setProperty('--cube-filter-top', top + 'px');
    tree.style.setProperty('margin', '0', 'important');
    tree.style.setProperty('top', top + 'px', 'important');
    tree.style.setProperty('height', 'calc(100% - ' + top + 'px)', 'important');
  }

  /* ---------- 4. sfondo scuro ---------- */

  function overlay() {
    if (!document.getElementById('gf-tree')) return;
    if (document.querySelector('.cube-filter-overlay')) return;

    var ov = document.createElement('div');
    ov.className = 'cube-filter-overlay';
    ov.addEventListener('click', closePanel);
    document.body.appendChild(ov);
  }

  /* ---------- 5. colore sotto il titolo ---------- */
  /* Stessa cosa fatta in pagina prodotto e nelle schede del carosello: il
     nome del colore esce dal titolo e va su una riga sua, piccola, maiuscola
     e grigia.

     Il colore lo porta il metafield "custom.colore", che il modello di Globo
     mette in data-colore, ma sui prodotti e' vuoto: allora si ricava
     dall'ultima parola del titolo, con la stessa regola di
     snippets/cube-colore.liquid, dove il colore e' sempre in fondo:
       - se contiene "n" fra due accenti (topasblue´n´white) e' un colore;
       - altrimenti vale solo se tutta minuscola, lunga almeno 5 lettere e
         senza cifre (teamline, actionteam). I nomi dei modelli CUBE sono
         maiuscoli o contengono numeri, quindi restano nel titolo.
     Se il metafield un giorno verra' popolato, quello ha la precedenza.

     Nel modello di Globo il colore era gia' previsto accanto al codice, nella
     riga .sku: quel pezzo resta com'e' e si accende da solo se il metafield
     viene compilato, quindi qui la riga viene aggiunta solo quando quel testo
     non c'e'. */

  function splitColor(title) {
    var words = title.trim().split(/\s+/);
    if (words.length < 2) return null;

    var last = words[words.length - 1];

    if (last.indexOf('´n´') === -1) {
      if (last !== last.toLowerCase()) return null;
      if (last.length < 5) return null;
      if (/[0-9]/.test(last)) return null;
    }

    return { title: words.slice(0, -1).join(' '), color: last };
  }

  function titles() {
    var cards = document.querySelectorAll('.spf-product-card__title');
    for (var i = 0; i < cards.length; i++) {
      var el = cards[i];
      if (el.dataset.cubeTitle === '1') continue;
      el.dataset.cubeTitle = '1';

      var link = el.querySelector('a');
      if (!link) continue;

      var text = link.textContent.trim();
      var colore = (el.dataset.colore || '').trim();

      if (colore) {
        /* metafield compilato: lo togliamo dalla coda del titolo e la riga
           accanto al codice ci pensa il modello di Globo */
        if (text.length > colore.length &&
            text.slice(-colore.length).toLowerCase() === colore.toLowerCase()) {
          link.textContent = text.slice(0, text.length - colore.length).trim();
        }
        continue;
      }

      var parts = splitColor(text);
      if (!parts) continue;

      link.textContent = parts.title;

      var line = document.createElement('div');
      line.className = 'cube-card-colore';
      line.textContent = parts.color;
      el.parentElement.insertBefore(line, el.nextSibling);
    }
  }

  /* ---------- 6. rete di sicurezza ---------- */
  /* Nelle collezioni le schede del tema sono nascoste dal primo istante (vedi
     cube-card.css), perche' comanda Globo. Se pero' l'app non parte - errore
     suo, script bloccati, rete lenta - la pagina resterebbe senza prodotti:
     dopo 8 secondi senza nessuna scheda dell'app, la griglia del tema torna
     visibile.

     Importante: il controllo non e' una tantum. Se Globo arriva in ritardo,
     per esempio su una connessione lenta o su Safari, che carica gli script
     di terze parti con piu' calma, la classe va tolta appena compaiono le sue
     schede. Senza questo, la griglia del tema restava visibile in fondo alla
     pagina per sempre, che e' esattamente il difetto che la rete di sicurezza
     doveva evitare. Il controllo gira dentro run(), quindi a ogni modifica
     del DOM. */

  function fallback() {
    var main = document.getElementById('MainContent');
    if (!main) return;

    var tpl = main.dataset.template;
    if (tpl !== 'collection' && tpl !== 'search') return;

    /* l'app e' arrivata: via la rete di sicurezza, se era stata messa */
    if (document.querySelector('.spf-product-card')) {
      main.classList.remove('cube-globo-off');
      return;
    }

    if (main.dataset.cubeFallback === '1') return;
    main.dataset.cubeFallback = '1';

    setTimeout(function () {
      if (!document.querySelector('.spf-product-card')) {
        main.classList.add('cube-globo-off');
      }
    }, 8000);
  }

  /* ---------- avvio ---------- */

  var queued = false;
  function run() {
    queued = false;
    placeTrigger();
    labels();
    panel();
    overlay();
    titles();
    fallback();
  }
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(run);
  }

  function remeasure() {
    var tree = document.getElementById('gf-tree');
    if (tree) delete tree.dataset.cubeTop;
    schedule();
  }

  function init() {
    run();
    if (!document.body) return;
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', remeasure);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && document.documentElement.classList.contains('offcanvas-open')) closePanel();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
